module.exports = __webpack_public_path__ + "img/swipe.07f2c62d.svg";